import { useState, useRef, useCallback } from 'react';
import { useLocation } from 'react-router';

import { selectText } from '@hotjar/webapp/utils/select-text';
import { ShortLinkDropdown, ShortLinkWrapper } from '@hotjar/webapp/features/ShortLink';
import { ShortLinkDropdownSkeletonLoader } from '@hotjar/webapp/features/ShortLink/ShortLinkDropdownSkeletonLoader';
import { getItemFromUrl } from '@hotjar/webapp/features/ShortLinkWidget/ShortLinkWidget';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

interface SharingModuleProps {
  onShare?: () => void;
  title?: string;
  trigger: JSX.Element;
}

export const SharingModule = ({ onShare, title, trigger }: SharingModuleProps): JSX.Element => {
  const [isShown, setIsShown] = useState(false);
  const outputRef = useRef<HTMLOutputElement | null>(null);
  const { itemShared } = useTrack();
  const location = useLocation();

  const selectAndCopy = useCallback(() => {
    if (outputRef.current !== null) {
      selectText(outputRef.current);
    }

    itemShared({ item: getItemFromUrl(location.pathname) });

    if (onShare) {
      onShare();
    }
  }, [onShare, location, itemShared]);

  const onDropdownOpened = () => {
    setIsShown(true);
  };

  const onDropdownClosed = () => {
    setIsShown(false);
  };

  return (
    <ShortLinkWrapper
      appendTo="parent"
      onShown={onDropdownOpened}
      onHidden={onDropdownClosed}
      trigger={trigger}
    >
      {isShown ? (
        <ShortLinkDropdown title={title} onCopy={selectAndCopy} ref={outputRef} />
      ) : (
        <ShortLinkDropdownSkeletonLoader title={title} />
      )}
    </ShortLinkWrapper>
  );
};
